import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type PersistEverflowTransactionIdMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PersistEverflowTransactionIdMutation = { __typename?: 'Mutation', persistEverflowTransactionId: { __typename?: 'EverflowTransactionPersistResult', status: Types.EverflowTransactionPersistStatus, transactionId: string | null } };


export const PersistEverflowTransactionIdDocument = gql`
    mutation persistEverflowTransactionId {
  persistEverflowTransactionId {
    status
    transactionId
  }
}
    ` as unknown as DocumentNode<PersistEverflowTransactionIdMutation, PersistEverflowTransactionIdMutationVariables>;